import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const Countdown = ({ startTime, dark, inline }) => {
  const [dates, setDates] = useState({})
  const calculateTimer = (startTime) => {
    // get total seconds between the times
    var delta = Math.abs(new Date(startTime).getTime() - Date.now()) / 1000

    // calculate (and subtract) whole days
    var days = Math.floor(delta / 86400)
    delta -= days * 86400

    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24
    delta -= hours * 3600

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60
    delta -= minutes * 60

    // what's left is seconds
    var seconds = Math.round(delta % 60) // in theory the modulus is not required
    setDates({
      days,
      hours,
      minutes,
      seconds,
    })
  }

  useEffect(() => {
    if (startTime) {
      calculateTimer(startTime)
      const timer = setInterval(() => {
        calculateTimer(startTime)
      }, 1000)
      return () => clearInterval(timer)
    }
  }, [startTime])

  if (dates && typeof dates.minutes !== 'undefined' && !inline) {
    return (
      <div className="max-w-xs m-auto">
        <div className="grid grid-flow-row grid-cols-4">
          <div className="flex flex-col items-center content-center pt-4 text-3xl mr-4">
            {dates.days}
            <span className={`text-sm ${dark ? 'text-gray-500' : 'text-gray-200'}`}>days</span>
          </div>
          <div className="flex flex-col items-center content-center pt-4 text-3xl mr-4">
            {dates.hours}
            <span className={`text-sm ${dark ? 'text-gray-500' : 'text-gray-200'}`}>hours</span>
          </div>
          <div className="flex flex-col items-center content-center pt-4 text-3xl mr-4">
            {dates.minutes}
            <span className={`text-sm ${dark ? 'text-gray-500' : 'text-gray-200'}`}>minutes</span>
          </div>
          <div className="flex flex-col items-center content-center pt-4 text-3xl">
            {dates.seconds}
            <span className={`text-sm ${dark ? 'text-gray-500' : 'text-gray-200'}`}>seconds</span>
          </div>
        </div>
      </div>
    )
  } else if (dates && typeof dates.minutes !== 'undefined' && inline) {
    const countDown = dates.days ? (
      <>
        {dates.days} <span className="text-sm">days. </span>
      </>
    ) : dates.hours ? (
      <>
        {dates.hours} <span className="text-sm">hours, </span>
        {dates.minutes} <span className="text-sm">minutes, </span>
        {dates.seconds} <span className="text-sm">seconds</span>
      </>
    ) : (
      <>
        {dates.minutes} <span className="text-sm">minutes, </span>
        {dates.seconds} <span className="text-sm">seconds</span>
      </>
    )
    return (
      <span className="block sm:inline">
        &nbsp;
        {countDown}
      </span>
    )
  } else return <></>
}

Countdown.propTypes = {
  startTime: PropTypes.string,
  dark: PropTypes.bool,
  inline: PropTypes.bool,
}

export default Countdown
